module.exports = __webpack_public_path__ + "img/logo.0c7addbe.svg";